import React, { useEffect, useState } from "react";
import "../../styles/CommonBbps.css";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import Call_Api from "../../Common/Handileapi/Call_api";
import { path } from "../../routes/Paths";
import { isInputValid } from "../../Common/creditCardBinAPI/CommonFunctions";
import { setDetailsToSend } from "../../redux/slice/detailsToSendSlice";
import { useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { data } from "../../Common/Text/NormalText";
import Header from "../../components/Header/Header";
import NtarLoader from "../../components/Loaders/NtarLoader";
import { useLocation } from "react-router-dom";

const InstantBbps = () => {
  const detailsToSend = useSelector((state) => state?.details?.details || {});
  console.log("detailsToSend in instant bbps ====>>", detailsToSend);
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const origin = location.state?.origin || "";

  const [parametersList, setParametersList] = useState([]);
  const [formData, setFormData] = useState({});
  const [touched, setTouched] = useState({});
  const [loading, setLoading] = useState(false);
  const [allFieldsValid, setAllFieldsValid] = useState(false);
  const [billFetchError, setBillFetchError] = useState(false);
  const [billFetchMandatory, setBillFetchMandatory] = useState(false);
  const [billamountValidations, setBillAmountValidations] = useState({
    minAmount: 0,
    maxAmount: 0,
  });
  const [billerId, setBillerId] = useState(null);
  const mapExistingToBillerParams = (billerParams = [], detailsToSend) => {
    if (!billerParams.length || !detailsToSend) return [];

    const existingMap = normalizeExistingParams(detailsToSend.parameters);

    return billerParams.map((param) => {
      let enteredValue = "";

      // ✅ CREDIT CARD → ALWAYS 16 DIGITS
      if (param.maxLength === 4 && detailsToSend.creditCardNumber) {
        enteredValue = detailsToSend.creditCardNumber;
      }

      // ✅ MOBILE NUMBER
      else if (param.maxLength === 10) {
        enteredValue =
          detailsToSend.customerMobileNumber ||
          existingMap["Registered Mobile Number"] ||
          existingMap["Mobile Number"] ||
          "";
      }

      // ✅ FALLBACK (DESC MATCH)
      else {
        enteredValue = existingMap[param.desc] || "";
      }

      return {
        ...param,
        enteredValue,
        key: param.name,
      };
    });
  };

  const normalizeExistingParams = (params) => {
    const result = {};

    // ✅ ARRAY HANDLING
    if (Array.isArray(params)) {
      params.forEach((p) => {
        if (p?.desc && p?.enteredValue) {
          result[p.desc] = p.enteredValue;
        }
      });
    }

    // ✅ OBJECT HANDLING
    else if (params && typeof params === "object") {
      Object.keys(params).forEach((key) => {
        result[key] = params[key];
      });
    }

    return result;
  };

  useEffect(() => {
    if (!parametersList.length) return;
    if (origin?.toLowerCase() !== "existing") return;

    const mappedParams = mapExistingToBillerParams(
      parametersList,
      detailsToSend
    );

    const restoredFormData = {};
    const restoredTouched = {};

    mappedParams.forEach((param) => {
      if (param.enteredValue) {
        restoredFormData[param.name] = param;
        restoredTouched[param.name] = true;
      }
    });

    if (Object.keys(restoredFormData).length) {
      setFormData(restoredFormData);
      setTouched(restoredTouched);

      if (billerId) {
        sessionStorage.setItem(
          `formData_${billerId}`,
          JSON.stringify(restoredFormData)
        );
      }

      console.log("✅ Prefilled (array + object safe)", restoredFormData);
    }
  }, [parametersList, detailsToSend, origin, billerId]);

  const isPrefilled =
    origin === "existing" &&
    detailsToSend?.parameters &&
    Object.keys(detailsToSend.parameters).length > 0;

  /* ---------------- HANDLE INPUT CHANGE ---------------- */
  const handleInputChange = (item, value) => {
    setBillFetchError("");
    let enteredValue = value;

    // Only credit card fields: remove non-digits and limit to 16
    if (isCreditCardInput(item)) {
      enteredValue = enteredValue.replace(/\D/g, "").slice(0, 16);
    }
    // Other fields: enforce their maxLength if defined
    else if (item?.maxLength) {
      enteredValue = enteredValue.slice(0, item.maxLength);
    }

    setFormData((prev) => {
      const updated = {
        ...prev,
        [item.name]: {
          ...item,
          enteredValue,
        },
      };

      if (billerId) {
        sessionStorage.setItem(`formData_${billerId}`, JSON.stringify(updated));
      }

      return updated;
    });

    setTouched((prev) => ({ ...prev, [item.name]: true }));
  };

  const isCreditCardInput = (item) => {
    if (!item) return false;

    return item?.maxLength === 4;
  };

  const isMobileNumberInput = (item) => {
    if (!item) return false;

    return item?.maxLength === 10;
  };

  /* ---------------- FETCH BILLER INFO ---------------- */
  const loadBillerInfo = async (id) => {
    if (!id || loading) return;

    setLoading(true);

    try {
      const cachedBiller = sessionStorage.getItem(`biller_${id}`);
      const cachedFormData = sessionStorage.getItem(`formData_${id}`);

      if (cachedBiller) {
        const data = JSON.parse(cachedBiller);
        setParametersList(data.parameters);
        setBillFetchMandatory(data.fetchRequirement === "MANDATORY");
        setBillerId(id);

        console.log("Loaded biller info from cache:", data);

        if (cachedFormData) {
          setFormData(JSON.parse(cachedFormData));
          console.log("Loaded formData from sessionStorage:", cachedFormData);
        }

        setLoading(false);
        return;
      }

      const res = await Call_Api(
        path.INSTANTPAY_BILLER_DETAILS,
        "POST",
        { billerId: id, billType: "billerInfo" },
        token
      );

      console.log("API response in loadBillerInfo ===>>", res);

      const data = res?.response?.data;
      const params = data?.parameters || [];

      const sortedParameters = [...params].sort((a, b) => {
        // put maxLength === 4 at the top
        if (a.maxLength === 4 && b.maxLength !== 4) return -1;
        if (a.maxLength !== 4 && b.maxLength === 4) return 1;

        // otherwise keep original order
        return 0;
      });

      setParametersList(sortedParameters);
      setBillFetchMandatory(data?.fetchRequirement === "MANDATORY");

      const checkAgt = data?.initChannels.find((items) =>
        items.name.includes("AGT")
      );
      const channelToBeSend = checkAgt ? "AGT" : "MOB";

      setBillerId(id);

      console.log("data?.initChannels ===>>", data?.initChannels);

      setBillAmountValidations({
        ...billamountValidations,
        minAmount: data?.initChannels?.[0]?.minAmount,
        maxAmount: data?.initChannels?.[0]?.maxAmount,
      });

      dispatch(
        setDetailsToSend({
          ...detailsToSend,
          externalRef: data?.externalRefId,
          initChannel: channelToBeSend,
        })
      );

      sessionStorage.setItem(
        `biller_${id}`,
        JSON.stringify({
          parameters: params,
          fetchRequirement: data?.fetchRequirement,
        })
      );
      sessionStorage.setItem("currentBillerId", id);

      console.log("Biller info stored in sessionStorage");
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- FORM VALIDATION ---------------- */
  useEffect(() => {
    const valid = parametersList.every((field) => {
      const value = formData[field.name]?.enteredValue || "";

      if (isCreditCardInput(field, detailsToSend)) {
        return /^[0-9]{16}$/.test(value);
      }

      return (
        value.length === field.maxLength && new RegExp(field.regex).test(value)
      );
    });

    setAllFieldsValid(valid);
    console.log("Form validation status:", valid);
  }, [formData, parametersList]);

  /* ---------------- LOAD ON REFRESH ---------------- */
  useEffect(() => {
    const storedBillerId = sessionStorage.getItem("currentBillerId");
    if (storedBillerId) {
      console.log("Found stored billerId:", storedBillerId);
      loadBillerInfo(storedBillerId);
    } else if (detailsToSend?.billerId) {
      loadBillerInfo(detailsToSend.billerId);
    }
  }, []);

  /* ---------------- CONTINUE ---------------- */
  const handleContinue = async () => {
    let creditCardNumber = "";
    let bbpsCreditCardNumber = "";
    let customerMobileNumber = "";

    console.log("formData ===>>", formData);

    const inputParams = Object.values(formData).map((field) => {
      if (isCreditCardInput(field) && field.enteredValue?.length > 10) {
        creditCardNumber = field.enteredValue;
        bbpsCreditCardNumber = field.enteredValue;
      }

      if (isMobileNumberInput(field) && field.enteredValue?.length == 10) {
        customerMobileNumber = field.enteredValue;
      }

      return {
        ...field,
        key: field?.name,
      };
    });

    let payload = {};

    if (billFetchMandatory) {
      payload = {
        ...detailsToSend,
        creditCardNumber,
        bbpsCreditCardNumber,
        inputParams,
        billType: "billFetch",
      };
    } else {
      payload = {
        ...detailsToSend,
        creditCardNumber,
        bbpsCreditCardNumber,
        inputParams,
        billType: "billValidation",
      };
    }

    console.log("payload for bill enquiry ===>>", payload);

    try {
      setLoading(true);

      if (billFetchMandatory) {
        const res = await Call_Api(
          path.INSTANTPAY_BILL_ENQUIRY,
          "POST",
          payload,
          token,
          { timeout: 30000 }
        );
        console.log("Bill Enquiry Response ===>>", res);
        const dtaFromBack = res?.response?.data?.data;
        if (res?.response?.data?.statuscode?.toUpperCase() === "TXN") {
          dispatch(
            setDetailsToSend({
              ...detailsToSend,
              CustomerName: dtaFromBack?.CustomerName,
              billAmount:
                Number(dtaFromBack?.BillAmount) > 200000
                  ? 200000
                  : dtaFromBack?.BillAmount,
              dueDate: dtaFromBack?.BillDueDate,
              billDate: dtaFromBack?.BillDate,
              requestId: dtaFromBack?.enquiryReferenceId,
              bbpsRequestId: dtaFromBack?.enquiryReferenceId,
              enquiryReferenceId: dtaFromBack?.enquiryReferenceId,
              creditCardNumber,
              outstandingDue: dtaFromBack.AdditionalDetails.find(
                (item) => item.Name === "Maximum Permissible Amount"
              )?.Value,
              bbpsCreditCardNumber,
              bbpsGateWay: "INSTANT_BBPS",
              customerMobileNumber:
                origin?.toLowerCase() == "existing"
                  ? detailsToSend?.customerMobileNumber
                  : dtaFromBack.CustomerParamsDetails.find((item) =>
                      item.Name.includes("Mobile Number")
                    )?.Value || customerMobileNumber,
              parameters: inputParams,
              inputParams,
              amountValidations: {
                ...billamountValidations,
                maxAmount:
                  Number(dtaFromBack?.BillAmount) > 200000
                    ? 200000
                    : dtaFromBack?.BillAmount,
              },
            })
          );
          navigate("/payInstant");
        } else {
          setBillFetchError(res?.response?.data?.status);
        }
      } else {
        const res = await Call_Api(
          path.INSTANTPAY_VALIDATE_BILL,
          "POST",
          payload,
          token,
          { timeout: 30000 }
        );
        console.log("Bill Validation Response ===>>", res);
        const dtaFromBack = res?.response?.data?.data;
        if (res?.response?.data?.statuscode?.toUpperCase() === "TXN") {
          dispatch(
            setDetailsToSend({
              ...detailsToSend,
              CustomerName: dtaFromBack?.CustomerName,
              billAmount:
                Number(dtaFromBack?.BillAmount) > 200000
                  ? 200000
                  : dtaFromBack?.BillAmount,
              dueDate: dtaFromBack?.BillDueDate,
              billDate: dtaFromBack?.BillDate,
              requestId: dtaFromBack?.enquiryReferenceId,
              bbpsRequestId: dtaFromBack?.enquiryReferenceId,
              enquiryReferenceId: dtaFromBack?.enquiryReferenceId,
              creditCardNumber,
              bbpsGateWay: "INSTANT_BBPS",
              outstandingDue: dtaFromBack.AdditionalDetails.find(
                (item) => item.Name === "Maximum Permissible Amount"
              )?.Value,
              bbpsCreditCardNumber,
              customerMobileNumber:
                origin?.toLowerCase() == "existing"
                  ? detailsToSend?.customerMobileNumber
                  : dtaFromBack.CustomerParamsDetails.find((item) =>
                      item.Name.includes("Mobile Number")
                    )?.Value || customerMobileNumber,
              parameters: inputParams,
              inputParams,
              amountValidations: {
                ...billamountValidations,
                minAmount: 100,
                maxAmount:
                  Number(dtaFromBack?.BillAmount) > 200000
                    ? 200000
                    : dtaFromBack?.BillAmount,
              },
            })
          );
          navigate("/payInstant");
        } else {
          setBillFetchError(res?.response?.data?.status);
        }
      }
    } catch (err) {
      console.error("Error during processing:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (detailsToSend?.parameters?.length && parametersList.length) {
      const restoredFormData = {};
      const restoredTouched = {};

      detailsToSend.parameters.forEach((param) => {
        restoredFormData[param.name] = {
          ...param,
          enteredValue: param.enteredValue,
        };
        restoredTouched[param.name] = true;
      });

      setFormData(restoredFormData);
      setTouched(restoredTouched);
    }
  }, [detailsToSend?.parameters, parametersList]);

  useEffect(() => {
    if (!detailsToSend?.serviceName) {
      navigate("/bbps/Credit Card", {
        replace: true,
        state: { record: "Credit Card" },
      });
    }
  }, [detailsToSend?.serviceName, navigate]);

  if (loading) {
    return <NtarLoader />;
  }

  return (
    <>
      <Header title="Credit Cards Bill Payments" />
      <div className="InstantBbps-container">
        <div className="back-icon-createlink_s_i">
          <KeyboardBackspaceIcon
            fontSize="large"
            onClick={() => {
              if (origin?.toLowerCase() == "existing") {
                sessionStorage.clear();
                dispatch(setDetailsToSend({ serviceName: "", subService: "" }));
                navigate("/CreditCardBillPayments");
              } else {
                sessionStorage.clear();
                dispatch(setDetailsToSend({ serviceName: "", subService: "" }));
                navigate("/bbps/Credit Card", {
                  state: { record: "Credit Card" },
                });
              }
            }}
          />
        </div>
        <div className="title_s">{data?.enterPay}</div>
        <div className="titleImage_s_i">
          <img
            src={detailsToSend?.billerLogo}
            alt="noImage"
            className="bbpsImage_s"
          />
          <p className="Note_s_wA">{detailsToSend?.subService}</p>
        </div>
        <div className="card_s_i">
          {parametersList.map((item, idx) => {
            const value = formData[item.name]?.enteredValue || "";

            const status = isCreditCardInput(item, detailsToSend)
              ? /^[0-9]{16}$/.test(value)
                ? "valid"
                : "InValid"
              : isInputValid(value, item.minLength, item.maxLength, item.regex);

            const showError = touched[item.name] && status === "InValid";

            return (
              <div key={idx} className="form-group my-3">
                <label>
                  {isCreditCardInput(item, detailsToSend)
                    ? "Enter 16 Digits of Credit Card Number"
                    : item.desc}
                  <span className="text-danger ms-1">*</span>
                </label>

                <input
                  type="text"
                  value={value}
                  disabled={isPrefilled}
                  maxLength={
                    isCreditCardInput(item, detailsToSend) ? 16 : item.maxLength
                  }
                  className={`form-control ${
                    status === "valid"
                      ? "is-valid"
                      : showError
                      ? "is-invalid"
                      : ""
                  }`}
                  onChange={(e) => handleInputChange(item, e.target.value)}
                  placeholder={
                    isCreditCardInput(item, detailsToSend)
                      ? "Enter 16 Digits of Credit Card Number"
                      : item.desc
                  }
                />

                {showError && (
                  <small className="text-danger">Invalid value</small>
                )}
              </div>
            );
          })}
          {billFetchError && <p className="error_s_i">{billFetchError}</p>}
          <p className="Note_s_wA">
            Note: Don't Refresh till the process is completed !
          </p>

          <button
            disabled={!allFieldsValid || loading || billFetchError}
            className="btn_s_i"
            onClick={handleContinue}
          >
            Continue
          </button>
        </div>
      </div>
    </>
  );
};

export default InstantBbps;

// import React, { useEffect, useState } from "react";
// import "../../styles/CommonBbps.css";
// import { useDispatch, useSelector } from "react-redux";
// import Cookies from "js-cookie";
// import Call_Api from "../../Common/Handileapi/Call_api";
// import { path } from "../../routes/Paths";
// import { isInputValid } from "../../Common/creditCardBinAPI/CommonFunctions";
// import { setDetailsToSend } from "../../redux/slice/detailsToSendSlice";
// import { useNavigate } from "react-router-dom";
// import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
// import { data } from "../../Common/Text/NormalText";
// import Header from "../../components/Header/Header";
// import NtarLoader from "../../components/Loaders/NtarLoader";
// import { useLocation } from "react-router-dom";

// const InstantBbps = () => {
//   const detailsToSend = useSelector((state) => state?.details?.details || {});
//   console.log("detailsToSend in instant bbps ====>>", detailsToSend);
//   const token = Cookies.get("token");
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const location = useLocation();
//   const origin =
//     location.state?.origin || sessionStorage.getItem("origin") || "";

//   console.log("origin", origin);

//   const [parametersList, setParametersList] = useState([]);
//   const [formData, setFormData] = useState({});
//   const [touched, setTouched] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [allFieldsValid, setAllFieldsValid] = useState(false);
//   const [billFetchError, setBillFetchError] = useState(false);
//   const [billFetchMandatory, setBillFetchMandatory] = useState(false);
//   const [billamountValidations, setBillAmountValidations] = useState({
//     minAmount: 0,
//     maxAmount: 0,
//   });
//   const [billerId, setBillerId] = useState(null);
//   const hasPlainInputParams =
//     detailsToSend?.inputParams &&
//     !Array.isArray(detailsToSend.inputParams) &&
//     typeof detailsToSend.inputParams === "object";

//   const mapInputParamsToBillerParams = (billerParams = [], inputParams) => {
//     if (!inputParams || !billerParams.length) return [];

//     return billerParams.map((param) => {
//       const valueFromInput =
//         inputParams[param.desc] ?? inputParams[param.name] ?? "";

//       return {
//         ...param,
//         enteredValue: valueFromInput,
//         key: param.name,
//       };
//     });
//   };

//   const normalizedParameters = React.useMemo(() => {
//     const params = detailsToSend?.parameters;

//     if (!params) return [];

//     // If already an array → use as is
//     if (Array.isArray(params)) return params;
//     if (typeof params === "object") return Object.values(params);

//     return [];
//   }, [detailsToSend?.parameters]);

//   useEffect(() => {
//     if (!parametersList.length) return;

//     const restoredFormData = {};
//     const restoredTouched = {};

//     // ------------------ CASE 1: normalized parameters ------------------
//     if (normalizedParameters.length) {
//       normalizedParameters.forEach((param) => {
//         restoredFormData[param.name] = {
//           ...param,
//           enteredValue: param.enteredValue || "",
//           key: param.name,
//         };
//         restoredTouched[param.name] = true;
//       });
//     }
//     // ------------------ CASE 2: plain inputParams ------------------
//     else if (hasPlainInputParams) {
//       const mappedParams = parametersList.map((param) => {
//         let value = "";

//         // full 16-digit credit card
//         if (param.maxLength === 16 && detailsToSend?.creditCardNumber) {
//           value = detailsToSend.creditCardNumber;
//         }
//         // 10-digit mobile number
//         else if (
//           param.maxLength === 10 &&
//           detailsToSend?.customerMobileNumber
//         ) {
//           value = detailsToSend.customerMobileNumber;
//         }
//         // match by length from inputParams
//         else {
//           for (const key in detailsToSend.inputParams) {
//             if (detailsToSend.inputParams[key]?.length === param.maxLength) {
//               value = detailsToSend.inputParams[key];
//               break;
//             }
//           }
//         }

//         return {
//           ...param,
//           enteredValue: value,
//           key: param.name,
//         };
//       });

//       mappedParams.forEach((param) => {
//         if (param.enteredValue?.length) {
//           restoredFormData[param.name] = param;
//           restoredTouched[param.name] = true;
//         }
//       });
//     }
//     // ------------------ CASE 3: existing origin ------------------
//     else if (origin?.toLowerCase() === "existing") {
//       parametersList.forEach((param) => {
//         // full 16-digit credit card
//         if (
//           param.name.toLowerCase().includes("creditcard") &&
//           detailsToSend?.creditCardNumber
//         ) {
//           restoredFormData[param.name] = {
//             ...param,
//             enteredValue: detailsToSend.creditCardNumber,
//           };
//           restoredTouched[param.name] = true;
//         }

//         // 10-digit mobile number
//         if (
//           param.name.toLowerCase().includes("mobile") &&
//           detailsToSend?.customerMobileNumber
//         ) {
//           restoredFormData[param.name] = {
//             ...param,
//             enteredValue: detailsToSend.customerMobileNumber,
//           };
//           restoredTouched[param.name] = true;
//         }
//       });
//     }

//     // ------------------ SET STATE ------------------
//     setFormData(restoredFormData);
//     setTouched(restoredTouched);
//   }, [
//     normalizedParameters,
//     hasPlainInputParams,
//     detailsToSend?.inputParams,
//     detailsToSend?.creditCardNumber,
//     detailsToSend?.customerMobileNumber,
//     parametersList,
//     origin,
//   ]);

//   const isPrefilled =
//     origin === "existing" &&
//     detailsToSend?.parameters &&
//     Object.keys(detailsToSend.parameters).length > 0;

//   /* ---------------- HANDLE INPUT CHANGE ---------------- */
//   const handleInputChange = (item, value) => {
//     setBillFetchError("");
//     let enteredValue = value;

//     // Only credit card fields: remove non-digits and limit to 16
//     if (isCreditCardInput(item)) {
//       enteredValue = enteredValue.replace(/\D/g, "").slice(0, 16);
//     }
//     // Other fields: enforce their maxLength if defined
//     else if (item?.maxLength) {
//       enteredValue = enteredValue.slice(0, item.maxLength);
//     }

//     setFormData((prev) => {
//       const updated = {
//         ...prev,
//         [item.name]: {
//           ...item,
//           enteredValue,
//         },
//       };

//       if (billerId) {
//         sessionStorage.setItem(`formData_${billerId}`, JSON.stringify(updated));
//       }

//       return updated;
//     });

//     setTouched((prev) => ({ ...prev, [item.name]: true }));
//   };

//   const isCreditCardInput = (item) => {
//     if (!item) return false;

//     return item?.maxLength === 4;
//   };

//   const isMobileNumberInput = (item) => {
//     if (!item) return false;

//     return item?.maxLength === 10;
//   };

//   /* ---------------- FETCH BILLER INFO ---------------- */
//   const loadBillerInfo = async (id) => {
//     if (!id || loading) return;

//     setLoading(true);

//     try {
//       const cachedBiller = sessionStorage.getItem(`biller_${id}`);
//       const cachedFormData = sessionStorage.getItem(`formData_${id}`);

//       if (cachedBiller) {
//         const data = JSON.parse(cachedBiller);
//         setParametersList(data.parameters);
//         setBillFetchMandatory(data.fetchRequirement === "MANDATORY");
//         setBillerId(id);

//         console.log("Loaded biller info from cache:", data);

//         if (cachedFormData) {
//           setFormData(JSON.parse(cachedFormData));
//           console.log("Loaded formData from sessionStorage:", cachedFormData);
//         }

//         setLoading(false);
//         return;
//       }

//       const res = await Call_Api(
//         path.INSTANTPAY_BILLER_DETAILS,
//         "POST",
//         { billerId: id, billType: "billerInfo" },
//         token
//       );

//       console.log("API response in loadBillerInfo ===>>", res);

//       const data = res?.response?.data;
//       const params = data?.parameters || [];

//       const sortedParameters = [...params].sort((a, b) => {
//         // put maxLength === 4 at the top
//         if (a.maxLength === 4 && b.maxLength !== 4) return -1;
//         if (a.maxLength !== 4 && b.maxLength === 4) return 1;

//         // otherwise keep original order
//         return 0;
//       });

//       setParametersList(sortedParameters);
//       setBillFetchMandatory(data?.fetchRequirement === "MANDATORY");

//       const checkAgt = data?.initChannels.find((items) =>
//         items.name.includes("AGT")
//       );
//       const channelToBeSend = checkAgt ? "AGT" : "MOB";

//       setBillerId(id);

//       console.log("data?.initChannels ===>>", data?.initChannels);

//       setBillAmountValidations({
//         ...billamountValidations,
//         minAmount: data?.initChannels?.[0]?.minAmount,
//         maxAmount: data?.initChannels?.[0]?.maxAmount,
//       });

//       dispatch(
//         setDetailsToSend({
//           ...detailsToSend,
//           externalRef: data?.externalRefId,
//           initChannel: channelToBeSend,
//         })
//       );

//       sessionStorage.setItem(
//         `biller_${id}`,
//         JSON.stringify({
//           parameters: params,
//           fetchRequirement: data?.fetchRequirement,
//         })
//       );
//       sessionStorage.setItem("currentBillerId", id);

//       console.log("Biller info stored in sessionStorage");
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ---------------- FORM VALIDATION ---------------- */
//   useEffect(() => {
//     const valid = parametersList.every((field) => {
//       const value = formData[field.name]?.enteredValue || "";

//       if (isCreditCardInput(field, detailsToSend)) {
//         return /^[0-9]{16}$/.test(value);
//       }

//       return (
//         value.length === field.maxLength && new RegExp(field.regex).test(value)
//       );
//     });

//     setAllFieldsValid(valid);
//     console.log("Form validation status:", valid);
//   }, [formData, parametersList]);

//   /* ---------------- LOAD ON REFRESH ---------------- */
//   useEffect(() => {
//     const storedBillerId = sessionStorage.getItem("currentBillerId");
//     if (storedBillerId) {
//       console.log("Found stored billerId:", storedBillerId);
//       loadBillerInfo(storedBillerId);
//     } else if (detailsToSend?.billerId) {
//       loadBillerInfo(detailsToSend.billerId);
//     }
//   }, []);

//   /* ---------------- CONTINUE ---------------- */
//   const handleContinue = async () => {
//     let creditCardNumber = "";
//     let bbpsCreditCardNumber = "";
//     let customerMobileNumber = "";

//     console.log("formData ===>>", formData);

//     const inputParams = Object.values(formData).map((field) => {
//       if (isCreditCardInput(field) && field.enteredValue?.length > 10) {
//         creditCardNumber = field.enteredValue;
//         bbpsCreditCardNumber = field.enteredValue;
//       }

//       if (isMobileNumberInput(field) && field.enteredValue?.length == 10) {
//         customerMobileNumber = field.enteredValue;
//       }

//       return {
//         ...field,
//         key: field?.name,
//       };
//     });

//     let payload = {};

//     if (billFetchMandatory) {
//       payload = {
//         ...detailsToSend,
//         creditCardNumber,
//         bbpsCreditCardNumber,
//         inputParams,
//         billType: "billFetch",
//       };
//     } else {
//       payload = {
//         ...detailsToSend,
//         creditCardNumber,
//         bbpsCreditCardNumber,
//         inputParams,
//         billType: "billValidation",
//       };
//     }

//     console.log("payload for bill enquiry ===>>", payload);

//     try {
//       setLoading(true);

//       if (billFetchMandatory) {
//         const res = await Call_Api(
//           path.INSTANTPAY_BILL_ENQUIRY,
//           "POST",
//           payload,
//           token,
//           { timeout: 30000 }
//         );
//         console.log("Bill Enquiry Response ===>>", res);
//         const dtaFromBack = res?.response?.data?.data;
//         if (res?.response?.data?.statuscode?.toUpperCase() === "TXN") {
//           dispatch(
//             setDetailsToSend({
//               ...detailsToSend,
//               CustomerName: dtaFromBack?.CustomerName,
//               billAmount:
//                 Number(dtaFromBack?.BillAmount) > 200000
//                   ? 200000
//                   : dtaFromBack?.BillAmount,
//               dueDate: dtaFromBack?.BillDueDate,
//               billDate: dtaFromBack?.BillDate,
//               requestId: dtaFromBack?.enquiryReferenceId,
//               bbpsRequestId: dtaFromBack?.enquiryReferenceId,
//               enquiryReferenceId: dtaFromBack?.enquiryReferenceId,
//               creditCardNumber,
//               outstandingDue: dtaFromBack.AdditionalDetails.find(
//                 (item) => item.Name === "Maximum Permissible Amount"
//               )?.Value,
//               bbpsCreditCardNumber,
//               bbpsGateWay: "INSTANT_BBPS",
//               customerMobileNumber:
//                 origin?.toLowerCase() == "existing"
//                   ? detailsToSend?.customerMobileNumber
//                   : dtaFromBack.CustomerParamsDetails.find((item) =>
//                       item.Name.includes("Mobile Number")
//                     )?.Value || customerMobileNumber,
//               parameters: inputParams,
//               inputParams,
//               amountValidations: {
//                 ...billamountValidations,
//                 maxAmount:
//                   Number(dtaFromBack?.BillAmount) > 200000
//                     ? 200000
//                     : dtaFromBack?.BillAmount,
//               },
//             })
//           );
//           navigate("/payInstant");
//         } else {
//           setBillFetchError(res?.response?.data?.status);
//           clearCreditCardAndMobileFields();
//         }
//       } else {
//         const res = await Call_Api(
//           path.INSTANTPAY_VALIDATE_BILL,
//           "POST",
//           payload,
//           token,
//           { timeout: 30000 }
//         );
//         console.log("Bill Validation Response ===>>", res);
//         const dtaFromBack = res?.response?.data?.data;
//         if (res?.response?.data?.statuscode?.toUpperCase() === "TXN") {
//           dispatch(
//             setDetailsToSend({
//               ...detailsToSend,
//               CustomerName: dtaFromBack?.CustomerName,
//               billAmount:
//                 Number(dtaFromBack?.BillAmount) > 200000
//                   ? 200000
//                   : dtaFromBack?.BillAmount,
//               dueDate: dtaFromBack?.BillDueDate,
//               billDate: dtaFromBack?.BillDate,
//               requestId: dtaFromBack?.enquiryReferenceId,
//               bbpsRequestId: dtaFromBack?.enquiryReferenceId,
//               enquiryReferenceId: dtaFromBack?.enquiryReferenceId,
//               creditCardNumber,
//               bbpsGateWay: "INSTANT_BBPS",
//               outstandingDue: dtaFromBack.AdditionalDetails.find(
//                 (item) => item.Name === "Maximum Permissible Amount"
//               )?.Value,
//               bbpsCreditCardNumber,
//               customerMobileNumber:
//                 origin?.toLowerCase() == "existing"
//                   ? detailsToSend?.customerMobileNumber
//                   : dtaFromBack.CustomerParamsDetails.find((item) =>
//                       item.Name.includes("Mobile Number")
//                     )?.Value || customerMobileNumber,
//               parameters: inputParams,
//               inputParams,
//               amountValidations: {
//                 ...billamountValidations,
//                 minAmount: 100,
//                 maxAmount:
//                   Number(dtaFromBack?.BillAmount) > 200000
//                     ? 200000
//                     : dtaFromBack?.BillAmount,
//               },
//             })
//           );
//           navigate("/payInstant");
//         } else {
//           setBillFetchError(res?.response?.data?.status);
//           clearCreditCardAndMobileFields();
//         }
//       }
//     } catch (err) {
//       console.error("Error during processing:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!detailsToSend?.serviceName) {
//       navigate("/bbps/Credit Card", {
//         replace: true,
//         state: { record: "Credit Card" },
//       });
//     }
//   }, [detailsToSend?.serviceName, navigate]);

//   if (loading) {
//     return <NtarLoader />;
//   }

//   const clearCreditCardAndMobileFields = () => {
//     setFormData((prev) => {
//       const updated = { ...prev };

//       Object.keys(updated).forEach((key) => {
//         const field = updated[key];

//         if (isCreditCardInput(field) || isMobileNumberInput(field)) {
//           updated[key] = {
//             ...field,
//             enteredValue: "",
//           };
//         }
//       });

//       // update sessionStorage also
//       if (billerId) {
//         sessionStorage.setItem(`formData_${billerId}`, JSON.stringify(updated));
//       }

//       return updated;
//     });

//     setTouched((prev) => {
//       const updatedTouched = { ...prev };

//       Object.keys(updatedTouched).forEach((key) => {
//         const field = formData[key];

//         if (isCreditCardInput(field) || isMobileNumberInput(field)) {
//           updatedTouched[key] = false;
//         }
//       });

//       return updatedTouched;
//     });
//   };

//   return (
//     <>
//       <Header title="Credit Cards Bill Payments" />
//       <div className="InstantBbps-container">
//         <div className="back-icon-createlink_s_i">
//           <KeyboardBackspaceIcon
//             fontSize="large"
//             onClick={() => {
//               sessionStorage.removeItem(`formData_${billerId}`);
//               sessionStorage.removeItem("currentBillerId");
//               sessionStorage.removeItem(`biller_${billerId}`);
//               sessionStorage.removeItem("origin");

//               dispatch(setDetailsToSend({ serviceName: "", subService: "" }));

//               if (origin?.toLowerCase() === "existing") {
//                 navigate("/CreditCardBillPayments");
//               } else {
//                 navigate("/bbps/Credit Card", {
//                   state: { record: "Credit Card" },
//                 });
//               }
//             }}
//           />
//         </div>
//         <div className="title_s">{data?.enterPay}</div>
//         <div className="titleImage_s_i">
//           <img
//             src={detailsToSend?.billerLogo}
//             alt="noImage"
//             className="bbpsImage_s"
//           />
//           <p className="Note_s_wA">{detailsToSend?.subService}</p>
//         </div>
//         <div className="card_s_i">
//           {parametersList.map((item, idx) => {
//             const value = formData[item.name]?.enteredValue || "";

//             const status = isCreditCardInput(item, detailsToSend)
//               ? /^[0-9]{16}$/.test(value)
//                 ? "valid"
//                 : "InValid"
//               : isInputValid(value, item.minLength, item.maxLength, item.regex);

//             const showError = touched[item.name] && status === "InValid";

//             return (
//               <div key={idx} className="form-group my-3">
//                 <label>
//                   {isCreditCardInput(item, detailsToSend)
//                     ? "Enter 16 Digits of Credit Card Number"
//                     : item.desc}
//                   <span className="text-danger ms-1">*</span>
//                 </label>

//                 <input
//                   type="text"
//                   value={value}
//                   disabled={isPrefilled}
//                   maxLength={
//                     isCreditCardInput(item, detailsToSend) ? 16 : item.maxLength
//                   }
//                   className={`form-control ${
//                     status === "valid"
//                       ? "is-valid"
//                       : showError
//                       ? "is-invalid"
//                       : ""
//                   }`}
//                   onChange={(e) => handleInputChange(item, e.target.value)}
//                   placeholder={
//                     isCreditCardInput(item, detailsToSend)
//                       ? "Enter 16 Digits of Credit Card Number"
//                       : item.desc
//                   }
//                 />

//                 {showError && (
//                   <small className="text-danger">Invalid value</small>
//                 )}
//               </div>
//             );
//           })}
//           {billFetchError && <p className="error_s_i">{billFetchError}</p>}
//           <p className="Note_s_wA">
//             Note: Don't Refresh till the process is completed !
//           </p>

//           <button
//             disabled={!allFieldsValid || loading || billFetchError}
//             className="btn_s_i"
//             onClick={handleContinue}
//           >
//             Continue
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };

// export default InstantBbps;
